import { useContext } from 'react';
import { useStore } from './useStore';
import { PropertyType } from '../types';
import { AuthContext } from '../../logic';

const useFilters = (): any => {
	const [{ filters }, dispatch] = useStore();
	const { token } = useContext(AuthContext);

	const getFilters = (prevState: PropertyType[], newValue: PropertyType[]) => {
		if (!newValue?.length) return prevState;

		const updatedFilters = [...prevState].filter((filter: PropertyType) => {
			return !newValue.some((newFilter) => filter.name === newFilter.name);
		});

		newValue.forEach((newFilter) => {
			if (newFilter.value) {
				updatedFilters.push(newFilter);
			}
		});

		return updatedFilters;
	};

	const onFilter = (value: PropertyType[]) => {
		dispatch('LOADING', true);
		const payload = {
			token,
			page: 1,
			filters: getFilters(filters, value),
		};
		dispatch('UPDATE_FILTERS', getFilters(filters, value));
		dispatch('FILTER', payload);
	};

	return { onFilter };
};

export default useFilters;
